<template>
  <div class="listing-list-box">
    <div class="main-container">
      <h2 class="">リスティング設定</h2>
      <div class="list-box">
        <div class="list-header-box">
          <div class="flex">
            <p class="list-item1"></p>
            <p class="list-item3">部屋番号(部屋名)</p>
            <!-- <p class="list-item2">カギ情報</p>
            <p class="list-item2">宅配ボックス</p>
            <p class="list-item2">WIFI</p>
            <p class="list-item2">Poket WIFI</p> -->
          </div>
        </div>

        <div class="list-contents-box">
          <div class="flex" v-for="(list, index) in lists" :key="index">
            <p class="list-item1 center"><a class="" @click="list_info(list)">詳細</a></p>
            <p class="list-item3">{{list.name}}</p>
            <!-- <p class="list-item2 center" :class="status_class(list.key_url)" >{{status_text(list.key_url)}}</p>
            <p class="list-item2 center" :class="status_class(list.delivery_box)" >{{status_text(list.delivery_box)}}</p>
            <p class="list-item2 center" :class="status_class(list.wifi)" >{{status_text(list.wifi)}}</p>
            <p class="list-item2 center" :class="status_class(list.pocket_wifi)" >{{status_text(list.pocket_wifi)}}</p> -->
          </div>
        </div>
      </div>

      <div class="btn-box">
        <input type="button" class="new-add" @click="new_add" value="新規登録" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ListingList',
  // ===========================================================================
  // components
  // ===========================================================================
  components: {
  },
  // ===========================================================================
  // data
  // ===========================================================================
  data () {
    return {
      lists: [],
    };
  },
  // ===========================================================================
  // computed
  // ===========================================================================
  computed: {
  },
  // ===========================================================================
  // created
  // ===========================================================================
  created () {
    this.data_get();
  },
  // ===========================================================================
  // mounted
  // ===========================================================================
  mounted () {
  },
  // ===========================================================================
  // destroyed
  // ===========================================================================
  destroyed () {
  },
  // ===========================================================================
  // methods
  // ===========================================================================
  methods: {
    data_get () {
      let ld = new this.$loader(this);
      ld._data_set({});
      ld._post_cb_f = this.data_get_cb;
      ld._load_start('listing_list_get.php');
    },
    data_get_cb (res) {
      this.lists = res.data.listings;
    },
    list_info (list) {
      this.$router.push({name: 'listing_edit', params: {list: list, mode: 'edit'}});
    },
    status_text (value) {
      if (value === true) {
        return '設定済';
      }
      return '未設定';
    },
    status_class (value) {
      if (value === true) {
        return 'status-on';
      }
      return 'status-off';
    },
    new_add () {
      this.$router.push({name: 'listing_edit', params: {mode: 'add'}});
    }
  },
  // ===========================================================================
  // watch
  // ===========================================================================
  watch: {
  },
};
</script>

<style lang="scss">
.listing-list-box {
  text-align: left;

  .main-container {
    .new-add {
      color: #fefefe;
      display: block;
      text-align: center;
      padding: 8px 8px 8px 8px;
      font-size: 16px;
      margin: 0px auto 0px auto;
      text-decoration: none;
      border-radius: 3px;
      width: 150px;
    }
    .list-box {
      overflow-y: auto;
      height: calc(100vh - 162px);
    }
    .list-header-box {
      position: sticky;
      top: 0;
      p {
        background: #fbfbfb;
        border-top: 1px solid #ceced2;
        border-left: 1px solid #ceced2;
        border-bottom: 1px solid #ceced2;
        padding: 10px;
        color: #24273b;

        text-align: center;
        box-sizing: border-box;
        height: 46px;
      }
      p:last-child {
        border-right: 1px solid #ceced2;
      }
    }
    .list-contents-box {

      p {
        background: #fbfbfb;
        border-bottom: 1px solid #ceced2;
        border-left: 1px solid #ceced2;
        padding: 8px;

        box-sizing: border-box;
        height: 40px;
      }
      p:last-child {
        border-right: 1px solid #ceced2;
      }
    }
    .list-item1 {
      min-width: 70px;
      max-width: 70px;
    }
    .list-item2 {
      min-width: 120px;
      max-width: 120px;
    }
    .list-item3 {
      min-width: 200px;
      flex: 1;
    }
  }
  .status-on {
    color: #33aa55;
    font-weight: bold;
  }
  .status-off {
    color: #999999;
  }
  .btn-box {
    display: flex;
    margin: 10px auto 0 auto;
    padding: 10px 0 10px 10px;
    background:#d7d7da;

    input {
      margin-right: 10px;
    }

    z-index: 900;
  }
  @media (max-width: 767px) {
    .main-container {
      .list-header-box {
      }
    }
  }
}
</style>
